import { appConfigInitialState } from './AppConfig';
import { checkoutInitialState } from './Checkout';
import { contentCardsInitialState } from './ContentCards';
import { freeFormInitialState } from './FreeForm';
import { integrationsInitialState } from './Integrations';
import { layoutInitialState } from './Layout';
import { purchaseModeInitialState } from './PurchaseMode';
import { plansInitialState } from './Plans';
import { secondScreenInitialState } from './SecondScreen';
import { promoCodeInitialState } from './PromoCode';
import { userInitialState } from './User';
import { trackingInitialState } from './Tracking/initialState';

const zustandInitialState = {
  appConfig: appConfigInitialState,
  contentCards: contentCardsInitialState,
  checkout: checkoutInitialState,
  freeForm: freeFormInitialState,
  integrations: integrationsInitialState,
  pageLayout: layoutInitialState,
  secondScreen: secondScreenInitialState,
  purchaseMode: purchaseModeInitialState,
  promoCode: promoCodeInitialState,
  user: userInitialState,
  tracking: trackingInitialState,
  plans: plansInitialState,
};

export default zustandInitialState;
